import React from 'react';
import printQueueStyles from '../../stylesheets/management_site/modals/printQueueModal.module.scss';

export default class PrintQueueModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...this.props };
    this.selectedGroup = null;
    this.handleGroupSelection = this.handleGroupSelection.bind(this);
    this.handleSingleItemSelection = this.handleSingleItemSelection.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleClearAll = this.handleClearAll.bind(this);
    this.handlePrint = this.handlePrint.bind(this);
    this.handleUserOptionChange = this.handleUserOptionChange.bind(this);
  }

  componentDidMount() {
    initReactSelect2('#user-filter', this.handleUserOptionChange, null);
  }

  //Helper Function to update all items as selected/de-selected in a group
  updateGroupItems(groupedPrintItems, groupId, selected) {
    if (typeof groupedPrintItems[groupId] !== 'undefined') {
      var selectedGroup = groupedPrintItems[groupId];
      selectedGroup['selected'] = selected;
      selectedGroup['printItems'].forEach(function (i) {
        i['selected'] = selected;
      });
    }
  }

  handleSingleItemSelection(event) {
    var groupId = $(event.target).parent().data('group-id');
    var printItemId = $(event.target).parent().data('item-id');
    var groupedPrintItems = JSON.parse(
      JSON.stringify(this.state.groupedPrintItems)
    );
    if (this.selectedGroup != groupId) {
      this.updateGroupItems(groupedPrintItems, this.selectedGroup, false);
      this.selectedGroup = groupId;
    } else if (!groupedPrintItems[groupId]['allowMultiPrint']) {
      this.updateGroupItems(groupedPrintItems, groupId, false);
    }
    groupedPrintItems[groupId]['printItems'].forEach(function (i) {
      if (i.printItemId == printItemId) i['selected'] = !i['selected'];
    });
    this.setState({ groupedPrintItems: groupedPrintItems });
  }

  handleGroupSelection(event) {
    var groupId = $(event.target).parent().data('group-id');
    var groupedPrintItems = JSON.parse(
      JSON.stringify(this.state.groupedPrintItems)
    );
    if (this.selectedGroup == groupId) {
      this.updateGroupItems(groupedPrintItems, groupId, false);
      this.selectedGroup = null;
    } else {
      this.updateGroupItems(groupedPrintItems, this.selectedGroup, false); //Deselect any group
      this.updateGroupItems(groupedPrintItems, groupId, true); //Select New Group
      this.selectedGroup = groupId;
    }
    this.setState({ groupedPrintItems: groupedPrintItems });
  }

  handleDelete(event) {
    const target = event.currentTarget;
    var that = this;
    var printItemId = $(target).data('item-id');
    confirm(
      'Are you sure you want to remove this check from the print queue?',
      function (ok) {
        if (ok) {
          $(target).prop('disabled', true);
          that.clearPrintQueue([printItemId], function () {
            $(target).prop('disabled', false);
          });
        }
      }
    );
  }

  // Helper Function to Clear Out Print Items
  // Accepts either an array of print item IDs or keyword 'all'
  clearPrintQueue(printItemIds, onComplete) {
    const that = this;

    let loginId = null;
    if ($('#user-filter option:selected').length > 0) {
      loginId = $('#user-filter option:selected').attr('value');
    }
    const requestData = {
      print_item_ids: printItemIds,
      login_id: loginId,
    };

    startLoadingSpinner('mdc-dialog-printing2');
    $.ajax({
      url: '/print/queue/remove_checks_from_queue_redesign',
      dataType: 'JSON',
      data: requestData,
      success: function (data) {
        if (data.errors.length > 1) {
          alert(
            'There was a problem deleting some of the print queue items: ' +
              data.errors
          );
        }
        var tmpGroupedPrintItems = JSON.parse(
          JSON.stringify(that.state.groupedPrintItems)
        );
        Object.keys(tmpGroupedPrintItems).forEach(function (key) {
          let deletedIndices = [];
          for (
            var i = 0;
            i < tmpGroupedPrintItems[key].printItems.length;
            i++
          ) {
            if (
              data.ids.includes(
                tmpGroupedPrintItems[key].printItems[i].printItemId
              )
            ) {
              deletedIndices.push(i);
            }
          }
          if (deletedIndices.length > 0) {
            for (var i = deletedIndices.length - 1; i >= 0; i--) {
              tmpGroupedPrintItems[key].printItems.splice(deletedIndices[i], 1);
            }

            if (tmpGroupedPrintItems[key].printItems.length == 0) {
              delete tmpGroupedPrintItems[key];
            }
          }
        });

        // Deleting the checks from the hash used to display queues for different users
        const tmpPrintQueueHash = deepCopyObject(that.state.printQueueHash);
        Object.keys(tmpPrintQueueHash).forEach(function (userId) {
          var groupedItemsForUser = tmpPrintQueueHash[userId];
          Object.keys(groupedItemsForUser).forEach(function (key) {
            let deletedIndices = [];
            for (
              let i = 0;
              i < groupedItemsForUser[key].printItems.length;
              i++
            ) {
              if (
                data.ids.includes(
                  groupedItemsForUser[key].printItems[i].printItemId
                )
              ) {
                deletedIndices.push(i);
              }
            }
            if (deletedIndices.length > 0) {
              for (let i = deletedIndices.length - 1; i >= 0; i--) {
                groupedItemsForUser[key].printItems.splice(
                  deletedIndices[i],
                  1
                );
              }

              if (groupedItemsForUser[key].printItems.length == 0) {
                delete groupedItemsForUser[key];
              }
            }
          });
        });

        that.setState({
          groupedPrintItems: tmpGroupedPrintItems,
          printQueueHash: tmpPrintQueueHash,
        });
      },
      complete: function () {
        $('#clear-all', '#mdc-dialog-printing2').prop('disabled', false);
        stopLoadingSpinner('mdc-dialog-printing2');
        if (typeof onComplete === 'function') {
          onComplete();
        }
      },
    });
  }

  handleClearAll(event) {
    const target = event.currentTarget;
    var modal = this;

    let confirmMessage = 'Are you sure you want to clear the print queue?';
    if (
      $('#user-filter option:selected').length > 0 &&
      $('#user-filter option:selected').attr('value') == '0'
    ) {
      confirmMessage = confirmMessage.replace('?', ' for all users?');
    }
    confirm(confirmMessage, function (ok) {
      if (ok) {
        $(target).prop('disabled', true);
        modal.clearPrintQueue('all', function () {
          $(target).prop('disabled', false);
        });
      }
    });
  }

  handlePrint(event) {
    const printBtn = event.currentTarget;
    if (this.selectedGroup == null) return false;
    if (
      typeof this.state.groupedPrintItems === 'undefined' ||
      typeof this.state.groupedPrintItems[this.selectedGroup] === 'undefined'
    )
      return false;
    var selectedItems = [];
    var selectedChecks = [];

    this.state.groupedPrintItems[this.selectedGroup]['printItems'].forEach(
      function (i) {
        if (i['selected']) {
          selectedItems.push(i['printItemId']);
          selectedChecks.push(i['checkId']);
        }
      }
    );

    if (selectedChecks.length > 0) {
      const that = this;
      $(printBtn).prop('disabled', true);
      startLoadingSpinner('mdc-dialog-printing2');
      $.ajax({
        url:
          that.state.groupedPrintItems[this.selectedGroup]['printUrl'] +
          selectedChecks.join(',') +
          '?update_audit_trail=TRUE',
        dataType: 'script',
        success: function () {
          confirmYesNo(
            'Would you like to remove the selected checks from the print queue?',
            function (ok) {
              if (ok) {
                that.clearPrintQueue(selectedItems);
              }
            }
          );
        },
        complete: function () {
          $(printBtn).prop('disabled', false);
          stopLoadingSpinner('mdc-dialog-printing2');
        },
      });
    } else {
      alert('Please select at least one check to print');
    }
  }

  handleUserOptionChange(event) {
    const selectedUser = $('#user-filter option:selected').attr('value');
    var selectedGroupPrintItems = this.state.printQueueHash[selectedUser];
    this.setState({ groupedPrintItems: selectedGroupPrintItems });
  }

  render() {
    const modal = this;
    const groupedPrintItems = modal.state.groupedPrintItems || {};
    const groupKeys = Object.keys(groupedPrintItems);
    const hasGroups = groupKeys.length !== 0;
    const selectedGroupKey =
      modal.selectedGroup && groupedPrintItems[modal.selectedGroup]
        ? modal.selectedGroup
        : groupKeys[0];
    const activeGroup = selectedGroupKey
      ? groupedPrintItems[selectedGroupKey]
      : null;
    const bullet = '\u2022';
    const selectAllId = 'print-queue-select-all';
    const summaryText = activeGroup
      ? `${activeGroup.name} ${bullet} ${activeGroup.printItems.length} in queue`
      : null;
    const selectedItems =
      activeGroup?.printItems.filter((item) => item.selected) || [];
    const selectedCount = selectedItems.length;
    const selectedAmount = selectedItems.reduce(
      (total, item) => total + parseFloat(item.amount || 0),
      0
    );
    const formattedSelectedAmount = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(selectedAmount);
    const showClearAll = groupKeys.some(
      (key) => groupedPrintItems[key]?.printItems?.length > 0
    );
    const isPrintDisabled = selectedCount === 0;
    const printItemTables = [];

    if (hasGroups) {
      groupKeys.forEach(function (key) {
        const templateGroup = groupedPrintItems[key];
        const printItems = templateGroup.printItems.map(function (item) {
          let formattedAmount = parseFloat(item.amount).toFixed(2);
          const checkboxId = `print-queue-checkbox-${key}-${item.printItemId}`;
          return (
            <tr
              key={'printItem' + item.printItemId}
              className={printQueueStyles.tableRow}
            >
              <td className={printQueueStyles.checkboxCell}>
                <div className={printQueueStyles.checkboxWrap}>
                  <div
                    id={`mdc-js-checkbox-${key}-${item.printItemId}`}
                    data-group-id={key}
                    data-item-id={item.printItemId}
                    data-amount={formattedAmount}
                    data-testing-id={`${key}?parent_object_id=${item.checkId}`}
                    className="mdc-checkbox"
                    data-mdc-auto-init="MDCCheckbox"
                  >
                    <input
                      checked={item.selected}
                      type="checkbox"
                      id={checkboxId}
                      className="mdc-checkbox__native-control"
                      onClick={modal.handleSingleItemSelection}
                    />
                    <div className="mdc-checkbox__background">
                      <svg
                        className="mdc-checkbox__checkmark"
                        viewBox="0 0 24 24"
                      >
                        <path
                          className="mdc-checkbox__checkmark-path"
                          fill="none"
                          stroke="white"
                          d="M1.73,12.91 8.1,19.28 22.79,4.59"
                        />
                      </svg>
                      <div className="mdc-checkbox__mixedmark"></div>
                    </div>
                  </div>
                </div>
              </td>
              <td className={printQueueStyles.tableCell}>{item.date}</td>
              <td className={printQueueStyles.tableCell}>{item.checkNo}</td>
              <td className={printQueueStyles.tableCell}>{item.payee}</td>
              <td className={printQueueStyles.tableCell}>${formattedAmount}</td>
              <td className={printQueueStyles.tableCell}>{item.bankAccount}</td>
              <td className={printQueueStyles.tableCell}>{item.companies}</td>
              <td className={printQueueStyles.deleteCell}>
                <button
                  data-group-id={key}
                  data-item-id={item.printItemId}
                  className={`${printQueueStyles.deleteButton} pm-hide-mobile`}
                  onClick={modal.handleDelete}
                  type="button"
                >
                  <i className="mdi mdi-close"></i>
                </button>
                <button
                  data-group-id={key}
                  data-item-id={item.printItemId}
                  className={`${printQueueStyles.deleteTextButton} pm-hide-desktop`}
                  onClick={modal.handleDelete}
                  type="button"
                >
                  Remove
                </button>
              </td>
            </tr>
          );
        });
        printItemTables.push(
          <div
            key={'printQueueGroup' + key}
            className={printQueueStyles.groupSection}
          >
            {groupKeys.length > 1 && (
              <div className={printQueueStyles.groupHeader}>
                <span className={printQueueStyles.groupTitle}>
                  {templateGroup.name}
                </span>
                <span className={printQueueStyles.groupCount}>
                  {templateGroup.printItems.length} in queue
                </span>
              </div>
            )}
            <table className={printQueueStyles.table}>
              <colgroup>
                <col className={printQueueStyles.checkboxColumn} />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col className={printQueueStyles.deleteColumn} />
              </colgroup>
              <thead className={printQueueStyles.tableHead}>
                <tr>
                  <th className={printQueueStyles.checkboxHeaderCell}></th>
                  <th className={printQueueStyles.tableHeaderCell}>Date</th>
                  <th className={printQueueStyles.tableHeaderCell}>
                    Check No.
                  </th>
                  <th className={printQueueStyles.tableHeaderCell}>Payee</th>
                  <th className={printQueueStyles.tableHeaderCell}>Amount</th>
                  <th className={printQueueStyles.tableHeaderCell}>
                    Bank Account
                  </th>
                  <th className={printQueueStyles.tableHeaderCell}>
                    Company(s)
                  </th>
                  <th className={printQueueStyles.deleteHeaderCell}></th>
                </tr>
              </thead>
              <tbody>{printItems}</tbody>
            </table>
          </div>
        );
      });
    }

    let userMenuOptions = [];
    let userOptionsView = null;
    if (
      this.props.permissions["View other users' print queues"] == 'Full Access'
    ) {
      userMenuOptions.push(
        <option
          key={0}
          value="0"
          className="mdc-list-item"
          role="option"
          tabIndex="0"
        >
          All Users
        </option>
      );
      modal.state.userOptions.forEach(function (user) {
        var userId = user[0];
        var userName = user[1];
        userMenuOptions.push(
          <option
            key={userId}
            value={userId}
            className="mdc-list-item"
            role="option"
            tabIndex="0"
          >
            {userName}
          </option>
        );
      });
      userOptionsView = (
        <div className={printQueueStyles.userFilter}>
          <div className="pm-select">
            <label htmlFor="user-filter">Filter by User</label>
            <select
              id="user-filter"
              className="pm-default-select2-menu mdc-select pm-select-small"
              defaultValue={modal.props.defaultLogin}
            >
              {userMenuOptions}
            </select>
          </div>
        </div>
      );
    }

    return (
      <aside
        id="mdc-dialog-printing2"
        className={`mdc-dialog mdc-dialog--open print-queue-modal ${printQueueStyles.printQueueModal}`}
        role="alertdialog"
        aria-hidden="true"
        aria-labelledby="mdc-dialog-default-label"
        aria-describedby="mdc-dialog-default-description"
      >
        <div className="mdc-dialog__surface">
          <header className={`mdc-dialog__header ${printQueueStyles.header}`}>
            <div className={printQueueStyles.headerContent}>
              <h2
                id="mdc-dialog-default-label"
                className={`mdc-dialog__header__title ${printQueueStyles.headerTitle}`}
              >
                Print Queue
              </h2>
              {summaryText && (
                <span className={printQueueStyles.headerSubtitle}>
                  {summaryText}
                </span>
              )}
            </div>
          </header>
          <section
            id="mdc-dialog-default-description"
            className={`mdc-dialog__body mdc-dialog__body--scrollable ${printQueueStyles.body}`}
          >
            <div className={printQueueStyles.controlsRow}>
              <div className={printQueueStyles.controlsLeft}>
                {activeGroup?.allowMultiPrint && (
                  <label className={printQueueStyles.selectAllControl}>
                    <div
                      id="mdc-js-checkbox-select-all"
                      data-group-id={selectedGroupKey}
                      className="mdc-checkbox"
                      data-mdc-auto-init="MDCCheckbox"
                    >
                      <input
                        checked={activeGroup?.selected || false}
                        type="checkbox"
                        id={selectAllId}
                        className="mdc-checkbox__native-control"
                        onClick={modal.handleGroupSelection}
                      />
                      <div className="mdc-checkbox__background">
                        <svg
                          className="mdc-checkbox__checkmark"
                          viewBox="0 0 24 24"
                        >
                          <path
                            className="mdc-checkbox__checkmark-path"
                            fill="none"
                            stroke="white"
                            d="M1.73,12.91 8.1,19.28 22.79,4.59"
                          />
                        </svg>
                        <div className="mdc-checkbox__mixedmark"></div>
                      </div>
                    </div>
                    <span className={printQueueStyles.selectAllLabel}>
                      Select All
                    </span>
                  </label>
                )}
                {showClearAll && (
                  <button
                    id="clear-all"
                    type="button"
                    className={printQueueStyles.clearAllButton}
                    onClick={this.handleClearAll}
                  >
                    <span className={printQueueStyles.clearAllIcon}>
                      <i className="mdi mdi-close"></i>
                    </span>
                    <span className={printQueueStyles.clearAllText}>
                      Clear All
                    </span>
                  </button>
                )}
              </div>
              <div className={printQueueStyles.controlsRight}>
                {userOptionsView}
              </div>
            </div>
            <div className={printQueueStyles.tableSection}>
              {printItemTables}
              {printItemTables.length == 0 && (
                <div className={printQueueStyles.emptyState}>
                  There are no items in the print queue.
                </div>
              )}
            </div>
          </section>
          <footer className={`mdc-dialog__footer ${printQueueStyles.footer}`}>
            <div className={printQueueStyles.footerText}>
              {isPrintDisabled ? (
                'Select checks to enable printing.'
              ) : (
                <>
                  Ready to print{' '}
                  <span className={printQueueStyles.footerEmphasis}>
                    {selectedCount}
                  </span>{' '}
                  check(s) {bullet}{' '}
                  <span className={printQueueStyles.footerEmphasis}>
                    ${formattedSelectedAmount}
                  </span>
                </>
              )}
            </div>
            <div className={printQueueStyles.footerActions}>
              <button
                type="button"
                id="print-queue-cancel"
                className={`${printQueueStyles.footerButton} ${printQueueStyles.cancelButton} mdc-dialog__footer__button--cancelPM`}
              >
                Cancel
              </button>
              <button
                type="button"
                id="print-queue-print"
                className={`${printQueueStyles.footerButton} ${printQueueStyles.printButton} ${
                  isPrintDisabled ? printQueueStyles.printButtonDisabled : ''
                }`}
                onClick={this.handlePrint}
                disabled={isPrintDisabled}
              >
                Print
              </button>
            </div>
          </footer>
        </div>
        <div className="mdc-dialog__backdrop"></div>
      </aside>
    );
  }
}
